import axios from 'axios';

import HTTP from '../HTTP';
import store from '../../store/store';
import config from '../config/config';

const LOGIN_URL = 'connect/token';
const USERS_URL = 'users';

export async function login(site, email, password) {
  // eslint-disable-next-line no-useless-catch
  try {
    const data = {
      client_id: 'client_users',
      client_secret: 'secret',
      grant_type: 'granttype_logged',
      scope: 'offline_access scope_logged',
      site: site,
      email: email,
      password: password,
    };

    const dataTransform = [];
    // eslint-disable-next-line
    for (const p in data) {
      // eslint-disable-next-line
      dataTransform.push(encodeURIComponent(p) + '=' + encodeURIComponent(data[p]));
    }
    const response = await axios.post(config.AUTHORITY_URL + LOGIN_URL, dataTransform.join('&'));
    return response;
  } catch (e) {
    throw e;
  }
}

export async function refresh() {
  // eslint-disable-next-line no-useless-catch
  try {
    const data = {
      client_id: 'client_users',
      client_secret: 'secret',
      grant_type: 'refresh_token',
      refresh_token: store.getters['user/refreshToken'],
    };
    const dataTransform = [];
    // eslint-disable-next-line
    for (const p in data) {
      // eslint-disable-next-line
      dataTransform.push(encodeURIComponent(p) + '=' + encodeURIComponent(data[p]));
    }
    const response = await axios.post(config.AUTHORITY_URL + LOGIN_URL, dataTransform.join('&'));
    return response;
  } catch (e) {
    throw e;
  }
}

export async function getUser(email) {
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await HTTP.get(USERS_URL + '/' + email);
    return response;
  } catch (e) {
    throw e;
  }
}
